export default __webpack_public_path__ + "static/media/foot-right-back.fe1dd27f.png";